/**
 * Where the API lives, resolved when the app boots rather than when it is bundled.
 *
 * Vite inlines `import.meta.env.VITE_*` at build time, so a bundle built for staging
 * physically contains staging's API URL and cannot be deployed anywhere else. That forced a
 * separate build per environment and meant production ran a bundle that had never been
 * exercised on staging.
 *
 * `public/config.js` is copied to the deployment root untouched by the bundler, so it is the
 * one file that may differ between environments while the hashed assets stay identical.
 *
 * Precedence is deliberate: the runtime value only wins when actually set, so builds relying
 * on VITE_API_BASE_URL behave exactly as before. This also preserves the guarantee the old
 * deploy workflow called out — that the git-tracked .env.production.local cannot override a
 * real deployment's API base, because config.js outranks both.
 */

/** Matches the pre-existing fallback, trailing slash included, so local dev is unchanged. */
const LOCAL_FALLBACK = 'http://localhost:5107/api/';

function resolveApiBase() {
  const runtime = typeof window !== 'undefined' ? window.__BIZCORE_CONFIG__?.apiBase : undefined;
  if (runtime && runtime.trim() !== '') return runtime.trim();
  return import.meta.env.VITE_API_BASE_URL || LOCAL_FALLBACK;
}

export const API_BASE = resolveApiBase();
